module.exports = __webpack_public_path__ + "static/abe-27af0259218561b13913de4f8342dac8.svg";